import { useRef } from "react"


export default function useInView({ once = true, margin = "-30px 0px 0px 0px"} = {}) {
  const ref = useRef(null)
  return [ref]
}